import axios from "../axios"

const getApplications = (params = null) => {
    return axios
        .get(`/docflow/applications`, {params: params})
        .then(response => response.data)
}

const getApplication = (id) => {
    return axios
        .get(`docflow/applications/${id}`)
        .then(response => response.data)
}

const getApplicationSections = (id) => {
    return axios
        .get(`/docflow/applications/${id}/sections`)
        .then(response => response.data);
}

const returnApplication = (id, message) => {
    return axios
        .post(`docflow/applications/${id}/return`, {comment: message})
        .then(response => response.data)
}

const returnApplicationRemarks = (id, message) => {
    return axios
        .post(`docflow/applications/${id}/return-remarks`, {comment: message})
        .then(response => response.data)
}

const acceptApplication = (id, form) => {
    return axios
        .post(`docflow/applications/${id}/accept`, form)
        .then(response => response.data)
}

const refuseApplication = (id, message) => {
    return axios
        .post(`docflow/applications/${id}/refuse`, {comment: message})
        .then(response => response.data)
}

const sendToApplicantApplication = (id, message) => {
    return axios
        .post(`docflow/register/send-to-applicant/${id}`, {comment: message})
        .then(response => response.data)
}

const sendApplicationConclusion = (id) => {
    return axios
        .post(`docflow/applications/${id}/conclusion-send`)
        .then(response => response.data)
}

const completeApplicationConclusion = (id) => {
    return axios
        .post(`docflow/applications/${id}/conclusion/complete`)
        .then(response => response.data)
}

const getApplicationFile = (applicationId, fileId) => {
    return axios
        .get(`/docflow/applications/${applicationId}/file/${fileId}`)
        .then(response => response.data);
}

const getApplicationAdditionalFile = (applicationId, additionalId, fileId) => {
    return axios
        .get(`/docflow/applications/${applicationId}/additional-file/${additionalId}/files/${fileId}`)
        .then(response => response.data);
}

const getApplicationDocumentationFile = (applicationId, documentationId) => {
    return axios
        .get(`/docflow/applications/${applicationId}/documentation/${documentationId}/file`)
        .then(response => response.data);
}

const getApplicationAgreementFile = (applicationId, agreementId, fileId) => {
    return axios
        .get(`/docflow/applications/${applicationId}/agreement/${agreementId}/files/${fileId}`)
        .then(response => response.data);
}

const getApplicationAdditionalAgreementFile = (applicationId, agreementId, additionalAgreement, fileId) => {
    return axios
        .get(`/docflow/applications/${applicationId}/agreement/${agreementId}/additional-agreement/${additionalAgreement}/files/${fileId}`)
        .then(response => response.data);
}

const getApplicationDocumentFile = (applicationId, documentId, fileId) => {
    return axios
        .get(`/docflow/applications/${applicationId}/documents/${documentId}/files/${fileId}`, {responseType: 'blob'})
        .then(response => response.data);
}

const getApplicationVersions = (applicationId) => {
    return axios
        .get(`/docflow/applications/${applicationId}/versions`)
        .then(response => response.data);
}

const getApplicationActions = (applicationId, params) => {
    return axios
        .get(`/docflow/applications/${applicationId}/history`, {params: params})
        .then(response => response.data);
}

const sendApplicationRemark = (id) => {
    return axios
        .post(`docflow/applications/${id}/remarks-send`)
        .then(response => response.data)
}

const sendApplicationAgreementRemark = (id) => {
    return axios
        .post(`docflow/applications/${id}/agreement-remarks-send`)
        .then(response => response.data)
}

const acceptApplicationRemark = (id) => {
    return axios
        .post(`docflow/applications/${id}/remarks-accept`)
        .then(response => response.data)
}

const statusList = () => {
    return axios.get(`/docflow/applications/status/list`)
        .then(response => response.data)
}

const updateDeadline = (id, form) => {
    return axios
        .post(`docflow/applications/${id}/update-deadline`, form)
        .then(response => response.data)
}

const egrzApplication = (id) => {
    return axios.get(`/service/${id}`)
        .then(response => response.data)
}

const egrzDocumentFile = (applicationId, fileId) => {
    return axios.get(`/service/${applicationId}/file/${fileId}/show`)
        .then(response => response.data)
}

const storeAdditionalFile = (applicationId, form) => {
    return axios.post(`/docflow/applications/${applicationId}/additional-file/add`, form)
        .then(response => response.data)
}

const addEmployment = (applicationId, form) => {
    return axios.post(`/docflow/applications/${applicationId}/employment/add`, form)
        .then(response => response.data)
}

const downloadSectionFiles = (applicationId, documentId) => {
    return axios.get(`/docflow/applications/${applicationId}/documents/${documentId}/download/files`, {
        responseType: 'blob'
    })
}

const downloadAllSectionFiles = (applicationId) => {
    return axios.get(`/docflow/applications/${applicationId}/documents/download/all`, {
        responseType: 'blob'
    })
}

const downloadSelectSectionFiles = (applicationId, form) => {
    return axios.post(`/docflow/applications/${applicationId}/documents/download/select`, form,{
        responseType: 'blob'
    })
}

const getDocumentsVersionAdditionalFile = (applicationId, documentId, documentsVersionsAdditionalFileId) => {
    return axios.get(`/docflow/applications/${applicationId}/documents/${documentId}/versions-additional-file/${documentsVersionsAdditionalFileId}`)
        .then(response => response.data)
}

const getSectionOptions = (applicationId) => {
    return axios.get(`/docflow/applications/${applicationId}/documents`)
        .then(response => response.data);
}

export const getUsers = (applicationId) => {
    return axios.get(`/docflow/applications/${applicationId}/users`)
        .then(response => response.data)
}

export const deleteUser = (applicationId, userId) => {
    return axios.post(`/docflow/applications/${applicationId}/employment/${userId}/delete`)
        .then(response => response.data)
}

const getProjectDeveloperFile = (applicationId, projectDeveloperId, fileId) => {
    return axios.get(`/docflow/applications/${applicationId}/project-developer/${projectDeveloperId}/file/${fileId}`)
        .then(response => response.data)
}

export default {
    getApplications,
    getApplication,
    getApplicationSections,
    returnApplication,
    returnApplicationRemarks,
    acceptApplication,
    refuseApplication,
    sendToApplicantApplication,
    sendApplicationConclusion,
    completeApplicationConclusion,
    getApplicationFile,
    getApplicationAgreementFile,
    getApplicationAdditionalAgreementFile,
    getApplicationAdditionalFile,
    getApplicationDocumentationFile,
    getApplicationDocumentFile,
    getApplicationVersions,
    sendApplicationRemark,
    sendApplicationAgreementRemark,
    acceptApplicationRemark,
    getApplicationActions,
    statusList,
    updateDeadline,
    egrzApplication,
    egrzDocumentFile,
    storeAdditionalFile,
    addEmployment,
    downloadSectionFiles,
    downloadAllSectionFiles,
    downloadSelectSectionFiles,
    getDocumentsVersionAdditionalFile,
    getSectionOptions,
    getUsers,
    deleteUser,
    getProjectDeveloperFile,
}
